/**
 * S1-Welcome — design phase entry.
 * "Twelve questions and we'll build your scope."
 */
import { useNavigate } from 'react-router-dom';

export function DesignWelcome(): JSX.Element {
  const navigate = useNavigate();
  return (
    <div className="flow flow--single">
      <div className="stage-card">
        <h1>Twelve questions, and we&rsquo;ll have your scope.</h1>
        <p className="stage-card__lede">
          Each one is a decision that shapes the work &mdash; tile, vanity, fixtures, lighting.
          Answer what you know; &ldquo;I&rsquo;m not sure&rdquo; is always fine. You can stop and
          pick up where you left off any time.
        </p>
        <div className="pb-note pb-note--info">
          At the end you get a written scope of the work, and we&rsquo;ll send your free estimate
          by the end of the next business day.
        </div>
        <div className="q-actions">
          <button
            type="button"
            className="pb-btn pb-btn--next pb-btn--lg"
            onClick={() => navigate('/design/flow')}
          >
            Start
          </button>
        </div>
      </div>
    </div>
  );
}
